import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"

export enum ContactEnum {
  PRIMARY_HOLDER_EMAIL = "primaryHolder.email",
  PRIMARY_HOLDER_PHONE = "primaryHolder.phone",
  EMAIL = "email",
  PHONE = "phone",
  MOBILE = "mobile",
  FAX = "fax",
}

// Primary holder fields (email & phone) are informative only
export const contactSchema = Yup.object({
  [ContactEnum.EMAIL]: Yup.string().email().max(75).nullable().default(null),
  [ContactEnum.PHONE]: Yup.string().nullable().default(null),
  [ContactEnum.MOBILE]: Yup.string().nullable().default(null),
  [ContactEnum.FAX]: Yup.string().nullable().default(null),
})

export type ContactFormValues = YupTypes.InferType<typeof contactSchema>
